define(["jquery", "underscore", "marionette", "templates/common/chartjs.html", "chart.js/dist/chart", "lottie/build/player/lottie.min.js", "views/common/loadingAnimationData.json"], function ($, _, Marionette, chartTpl, Chart, lottie, lottieData) {
    return Marionette.ItemView.extend({
        template: chartTpl,
        ui: {
            "leftControls": ".left.carousel-control",
            "rightControls": ".right.carousel-control",
            "noData": ".no_data",
            "chartCanvas": ".chartjs-canvas",
            "loadingSpinner": ".loading-spinner-container",
        },

        templateHelpers: function () {
            return {
                navigation: this.navigation,
            };
        },

        events: {
            "click @ui.leftControls": function (e) {
                e.preventDefault();

                if ("left" === this.nextPagePosition) {
                    this._nextPage();
                } else {
                    this._prevPage();
                }
            },
            "click @ui.rightControls": function (e) {
                e.preventDefault();

                if ("right" === this.nextPagePosition) {
                    this._nextPage();
                } else {
                    this._prevPage();
                }
            },
        },

        initialize: function (config) {
            this.config = _.extend(
                {},
                {
                    color: window.chartColors,
                },
                config
            );
            this.nextPagePosition = _.has(config.pagination, "nextPagePosition") ? config.pagination.nextPagePosition : "right";
            this.length = _.has(config.pagination, "length") ? config.pagination.length : 10;
            this.navigation = _.has(config.pagination, "navigation") ? config.pagination.navigation : true;
            this.currentPage = 1;
        },
        
        onAttach: function () {
            lottie.loadAnimation({
                container: this.ui.loadingSpinner[0].querySelector('.loading-spinner'), // the dom element that will contain the animation
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: lottieData, // the path to the animation json
            });
            this.chart = new Chart(this.ui.chartCanvas[0].getContext("2d"), {
                type: this.config.chartType,
                data: {
                    labels: [],
                    datasets: [],
                },
                options: this.config.chartOptions,
                plugins: this.config.chartPlugins,
            });
            this.ui.chartCanvas.hide();
            this._doAjax();
        },

        reload: function () {
            this.currentPage = 1;

            this._doAjax();
        },

        _nextPage: function () {
            if(this.config.datepickerPagination !== undefined) {
                this.config.datepickerPagination.onNext();
            } else {
                if (this.totalPages >= this.currentPage + 1) {
                    this.currentPage++;
                    this._doAjax();
                }
            }
        },

        _prevPage: function () {
            if(this.config.datepickerPagination !== undefined) {
                this.config.datepickerPagination.onPrevious();
            } else {
                if (0 < this.currentPage - 1) {
                    this.currentPage--;
                    this._doAjax();
                }
            }
        },

        _doAjax: function () {
            var that = this;
            this.ui.noData.hide();

            var data = {
                start: Math.max(this.length * (this.currentPage - 1), 0),
                length: this.length,
            };

            // If the config contains a prepareData function, we'll run it.
            if (this.config.ajax.prepareData) {
                data = _.extend(data, this.config.ajax.prepareData());
            }

            // ALL the ajax options can be overiden. However I don't recommend overidding success().
            $.ajax(
                _.extend(
                    {
                        data: data,
                        beforeSend: () => {that.ui.loadingSpinner.show()},
                        complete: () => {that.ui.loadingSpinner.hide()},
                        success: function (data) {
                            const parsedChartData = that.config.ajax.parseChartData(data);
                            that.chart.clear();
                            that.chart.data = parsedChartData;
                            that.chart.update();
                            that.ui.chartCanvas.show();

                            that.recordsTotal = parseInt(data.recordsTotal);
                            that.recordsFiltered = parseInt(data.recordsFiltered);
                            that.totalPages = Math.ceil(that.recordsFiltered / that.length);

                            if (0 >= that.recordsTotal || parsedChartData === undefined || parsedChartData.datasets[0].data.length === 0) {
                                that.ui.noData.show();
                            }
                        },
                    },
                    this.config.ajax
                )
            );
        },
    });
});
